import { openReportState } from 'app/area/favourite/constants';
import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';

interface SavedFavouriteRouteProps {
  location: { query: { report: string }};
  params: { validFavouriteId: string; modifier1?: string; modifier2?: string };
}

export function SavedFavouriteRoute({
  location,
  params
}: SavedFavouriteRouteProps) {

  const report = location?.query?.report ?
    parseInt(location.query.report, 10) :
    undefined;
  
  const favouriteId = params?.validFavouriteId && parseInt(params.validFavouriteId, 10);

  const editSavedFavourite = params.modifier1 === openReportState.edit || params.modifier2 === openReportState.edit;
  
  const {
    createFavouriteDraftDefinition
  } = useActionCreators();
  
  useEffect(() => {
    const createDraft = () => {
      createFavouriteDraftDefinition(favouriteId, report, editSavedFavourite);
    };
    createDraft();
  }, []);

  return <SpinLoader />;
}
